import { useQuery } from '@tanstack/react-query';

import * as organizationServices from '../../services';

export const useGetBranding = options => {
  return useQuery(['branding'], () => organizationServices.getBranding(), options);
};
